module.exports = __webpack_public_path__ + "img/manager_icon.845c9d01.jpeg";